import { render, staticRenderFns } from "./EnvironmentCreate.vue?vue&type=template&id=2c4f53ce&scoped=true"
import script from "./EnvironmentCreate.vue?vue&type=script&lang=js"
export * from "./EnvironmentCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4f53ce",
  null
  
)

export default component.exports